// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  overflow: hidden;
  height: 100%;
}

.main-table {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%; /* or whatever */
}

.table-inner-container {
  height: 400px;
  width: 550px;
  overflow: auto;
}

.table-container {
  height: 10px;
}

.table {
  margin-bottom: 0rem;
}

td.mat-mdc-cell {
  padding-top: 6px;
  width: auto;
  padding-left: 5px;
}

th.mat-mdc-header-cell {
  width: 10%;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.header-row {
  border-bottom: 1px solid #eee;
  margin-bottom: 5px;
}

.btn {
  margin-left: 10px;
}

mat-form-field {
  font-size: 14px;
  width: 100%;
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  max-height: calc(100vh - 471px);
  overflow-y: auto;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.label-width {
  width: 134px;
}

.left-padding {
  margin-left: 15px;
}

.z-index {
  z-index: 9000;
}

.left-margin {
  margin-left: 140px;
}

.form-control:disabled, .form-control[readonly] {
  background-color: lightgray !important;
  opacity: 1;
}

h5 {
  text-align: center;
  text-decoration: underline;
}

.error-small {
  font-size: 12px;
}

.error-div {
  height: 22px;
}

.full-width {
  width: 100%;
}

.mat-mdc-select-panel {
  font-size: 12px;
  /* opacity: 1; */
}

.mat-pseudo-checkbox-checked, .mat-pseudo-checkbox-indeterminate, .mat-accent .mat-pseudo-checkbox-checked, .mat-accent .mat-pseudo-checkbox-indeterminate {
  background: #17a2b8;
}

.mat-mdc-select-panel .mat-mdc-optgroup-label, .mat-select-panel .mat-mdc-option {
  font-size: inherit;
  line-height: 1.5;
  height: 2em;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
